function updateHiddenInpayPayoutFields() {
  var selectTransactionType = $('#inpay_transaction_is_payout');
  var selector = '#inpay_transaction_customer_bank_id option:selected';
  var selectedBankTag = $(selector);
  var selectedBankOption = selectedBankTag.text();

  if (selectTransactionType.val() === 'true') {
    var bankName = '';
    var bankCountryName = '';

    if (selectedBankOption.lastIndexOf('(') !== -1) {
      var indexC = selectedBankOption.lastIndexOf('(');
      var indexA = indexC + 1;
      var indexB = selectedBankOption.length - 1;
      bankCountryName = selectedBankOption.slice(indexA, indexB).trim();
      bankName = selectedBankOption.slice(0, indexC).trim();
    }

    if (selectedBankTag.val() !== '') {
      $('#payout_bank_name').val(bankName);
    } else {
      $('#payout_bank_name').val('');
    }

    var valueSelector = ['#billing_address_country option:contains("', bankCountryName, '")'].join('');
    $('#payout_bank_country').val($(valueSelector).val());
  } else {
    $('#payout_bank_name').val('');
    $('#payout_bank_country').val('');
  }
}

function initInpayPaymentFields() {
  var selectTransactionType = $('#inpay_transaction_is_payout');

  if (selectTransactionType.val() === 'true') {
    $('label[for="order_description"]').removeClass('required');
    $('label[for="payout_order_id"]').addClass('required');
    $('label[for="payout_swift"]').addClass('required');
    $('label[for="payout_acc_number"]').addClass('required');
    $('label[for="payout_bank_address"]').addClass('required');
    $('label[for="payout_owner_name"]').addClass('required');
    $('label[for="payout_owner_address"]').addClass('required');
  } else {
    $('label[for="order_description"]').addClass('required');
    $('label[for="payout_order_id"]').removeClass('required');
    $('label[for="payout_swift"]').removeClass('required');
    $('label[for="payout_acc_number"]').removeClass('required');
    $('label[for="payout_bank_address"]').removeClass('required');
    $('label[for="payout_owner_name"]').removeClass('required');
    $('label[for="payout_owner_address"]').removeClass('required');
  }

  updateHiddenInpayPayoutFields();
}

function listenForInpayPaymentTypeChange() {
  initInpayPaymentFields();
  $('#inpay_transaction_is_payout').on('change', function () {
    initInpayPaymentFields();
  });
}

function listenForBankSelection() {
  $('#inpay_transaction_customer_bank_id').on('change', function () {
    updateHiddenInpayPayoutFields();
  });
}

var Inpay = {
  listenForInpayPaymentTypeChange: listenForInpayPaymentTypeChange,
  listenForBankSelection: listenForBankSelection
};
export default Inpay;